import { FC } from 'react';
import { LogoProps } from './types';

const WhiteLogo: FC<LogoProps> = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="182"
    height="48"
    viewBox="0 0 348.81 91.938"
    className={className ?? ''}
  >
    <g transform="translate(97.59 32.471)">
      <path
        d="M198.39,102.127V76.96h7.37l6,9.744,6-9.744h7.37v25.167H218.2V87.672l-6.435,9.853h-.146l-6.4-9.777v14.379Z"
        transform="translate(-198.39 -76.457)"
        fill="#fff"
      />
      <path
        d="M287.009,98.39a14.226,14.226,0,0,1-19.343.038,12.428,12.428,0,0,1-3.866-9.242v-.07a12.47,12.47,0,0,1,3.9-9.274,14.226,14.226,0,0,1,19.343-.038,12.428,12.428,0,0,1,3.866,9.242v.07a12.482,12.482,0,0,1-3.9,9.274Zm-14.238-4.477a6.365,6.365,0,0,0,9.22.038,6.778,6.778,0,0,0,1.8-4.764v-.07a6.857,6.857,0,0,0-1.833-4.8,6.028,6.028,0,0,0-4.64-2,5.926,5.926,0,0,0-4.586,1.958,6.843,6.843,0,0,0-1.779,4.764v.07A6.883,6.883,0,0,0,272.771,93.913Z"
        transform="translate(-228.429 -76.03)"
        fill="#fff"
      />
      <path
        d="M329.96,102.127V76.96h6.505l10.355,13.3V76.96h6.9v25.167h-6.11L336.86,88.321v13.806Z"
        transform="translate(-258.813 -76.457)"
        fill="#fff"
      />
      <path
        d="M396.409,102.127V83.071H388.86V76.96h22.074v6.111h-7.549v19.056Z"
        transform="translate(-285.862 -76.457)"
        fill="#fff"
      />
      <path
        d="M444.63,102.127V76.96h20.241v5.932H451.53V86.7h12.08v5.5H451.53v3.991h13.519v5.932Z"
        transform="translate(-311.474 -76.457)"
        fill="#fff"
      />
      <path
        d="M509.338,102.2A12.8,12.8,0,0,1,496.36,89.187v-.07a12.643,12.643,0,0,1,3.791-9.312,12.893,12.893,0,0,1,9.474-3.774A12.374,12.374,0,0,1,520.3,81.281l-5.251,4.061a6.951,6.951,0,0,0-5.5-2.947,5.515,5.515,0,0,0-4.3,1.925,6.881,6.881,0,0,0-1.709,4.726v.07a7.017,7.017,0,0,0,1.687,4.8,5.486,5.486,0,0,0,4.315,1.925,6,6,0,0,0,3.126-.773,10.178,10.178,0,0,0,2.552-2.282l5.251,3.737a14.7,14.7,0,0,1-4.6,4.185,13.086,13.086,0,0,1-6.543,1.493Z"
        transform="translate(-335.231 -76.03)"
        fill="#fff"
      />
      <path
        d="M576.069,98.39a14.226,14.226,0,0,1-19.343.038,12.428,12.428,0,0,1-3.866-9.242v-.07a12.471,12.471,0,0,1,3.9-9.274A14.226,14.226,0,0,1,576.1,79.8a12.428,12.428,0,0,1,3.867,9.242v.07a12.483,12.483,0,0,1-3.9,9.274Zm-14.238-4.477a6.364,6.364,0,0,0,9.22.038,6.777,6.777,0,0,0,1.8-4.764v-.07a6.858,6.858,0,0,0-1.833-4.8,6.028,6.028,0,0,0-4.64-2,5.925,5.925,0,0,0-4.586,1.958,6.843,6.843,0,0,0-1.779,4.764v.07A6.883,6.883,0,0,0,561.831,93.913Z"
        transform="translate(-361.178 -76.03)"
        fill="#fff"
      />
      <path
        d="M619.02,102.127V76.96h6.505l10.355,13.3V76.96h6.9v25.167h-6.11L625.92,88.321v13.806Z"
        transform="translate(-391.562 -76.457)"
        fill="#fff"
      />
    </g>
    <path
      d="M0,49.252C0,30.725,12.861,16.566,29.273,11.488V33.5h.006a20.265,20.265,0,0,0-8.328,15.84c0,13.344,9.832,23.1,21.831,23.1s21.837-9.764,21.837-23.1a20.116,20.116,0,0,0-7.677-15.332V24.576a22.262,22.262,0,0,0-27.663-.521V2.041A46.106,46.106,0,0,1,42.788,0,46.61,46.61,0,0,1,56.942,2.252v9.432c16.1,5.26,28.634,19.289,28.634,37.564,0,25.033-17.973,42.689-42.788,42.689S0,74.285,0,49.252Z"
      fill="#fff"
    />
  </svg>
);

export default WhiteLogo;
